import { Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconHistory } from "@tabler/icons-react";

const HistoryEmptyState = () => {
  return (
    <Stack
      direction="column"
      align="center"
      justify="center"
      className="al-p-16 al-text-center al-border al-border-dashed al-border-gray-200 al-rounded-lg al-bg-gray-50"
    >
      <IconHistory className="al-h-12 al-w-12 al-text-gray-400 al-mb-4" />
      <Typography variant="body" weight="medium" className="al-mb-2 al-text-gray-700">
        No execution history yet
      </Typography>
      <Typography variant="body" className="al-text-gray-500">
        History will appear here once the subscription runs
      </Typography>
    </Stack>
  );
};

export default HistoryEmptyState;
